
import { useContext, useEffect, useState } from 'react';
import { Box, Button, Chip, Divider } from "@mui/material";
import { BulkContext } from '../store/bulklist-filters-context';
import DownloadBulkCSV from './BulkDownload';

export default function BulkSummary({ isMobile, firstYear, lastYear }) {
    const {
        comparingCountries,
        setComparingCountries,
        setSelectedItems,
        setChecked,
        selectedItems,
    } = useContext(BulkContext);
    const [animationKey, setAnimationKey] = useState(0);

    const clearSelection = () => {
        setSelectedItems([]);
        setComparingCountries([]);
        setChecked([]);
        setAnimationKey(0);
    };

    useEffect(() => {
        setAnimationKey((prevKey) => prevKey + 1);
    }, [comparingCountries, selectedItems, firstYear, lastYear]);

    return (
        <>
            <Divider
                sx={{
                    margin: "12px 0 10px 0",
                    fontWeight: "bold",
                    display: { xs: 'none', sm: 'flex' }
                }}
            >
                <Chip label="Your selection" size="small" />
            </Divider>
            <Box
                sx={{
                    backgroundColor: "primary.light",
                    p: 1.5,
                    pt: isMobile ? 1 : 1.5,
                    mt: isMobile ? 0.5 : 2,
                    borderRadius: isMobile ? "0" : "10px",
                    border: "1px solid transparent",
                    borderColor: "primary.light",
                    fontSize: "13px",
                }}
            >
                <Box>
                    <Box
                        key={animationKey}
                        className="animated-selection"
                        sx={{
                            textAlign: isMobile ? "center" : "left",
                            fontWeight: isMobile ? "600" : "500",
                            textAlign: "center",
                        }}
                    >
                        From {firstYear} to {lastYear} - {comparingCountries.length}{" "}
                        {comparingCountries.length === 1 ? "country/region" : "countries/regions"},{" "}
                        {selectedItems.length}{" "}
                        {selectedItems.length === 1 ? "indicator" : "indicators"}
                    </Box>
                </Box>
                <Box sx={{ display: "flex", gap: 2, mt: isMobile ? 1 : 1.5 }}>
                    <DownloadBulkCSV />
                    <Button
                        variant="outlined"
                        size="medium"
                        sx={{ textTransform: "none", fontSize: "smaller", flex: 1 }}
                        onClick={() => {
                            clearSelection();
                        }}
                    >
                        Clear selection
                    </Button>
                </Box>
            </Box>
        </>
    );
}